import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faLinkSlash } from "@fortawesome/free-solid-svg-icons"

export const LinkSlash = (props) => {
  return <FontAwesomeIcon faIcon={faLinkSlash} {...props} />
}
